<div class="equalizer">
    <div class="bar" *ngFor="let bar of bars"></div>
</div>